import React, {useEffect} from "react";
import * as actions from "../../store/actions";
import connect from "react-redux/es/connect/connect";
import countries from "../../../assets/country_codes";
import countryFlag from "../../../assets/countryFlag";
import {FlagComponent} from "../../v2/components/countryFlag/flag";
import Chart from "react-google-charts";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import {arrayToDataTable} from "../../config/Utils";
import {Link} from "react-router-dom";

const Countries = (props) => {

    useEffect(() => {
        props.onAtcStatisticsPerCountryFetch();
        props.onCountriesCoveredFetch();
        props.onDrugsCountFetch();
    }, [])

    const renderCountriesWithoutAtcCoverage = () => {
        let remainingCountries = [];
        if (props.countryAtcStatistics && props.countriesCovered) {
            const atcCoveredCountries = [...props.countryAtcStatistics.keys()];
            for (const countryCode of props.countriesCovered) {
                if (atcCoveredCountries.indexOf(countryCode) === -1) {
                    remainingCountries.push(countryCode);
                }
            }
        }
        return remainingCountries.map(it => <div className='ibox col-4 px-3' key={it}>
            <div className="ibox-content">
                <Link to={`/countries/${it}`}>
                    <div className='d-flex justify-content-between'>
                        <div>
                            <h2 className='m-0 d-flex align-items-center'>
                                <FlagComponent imageName={countryFlag[it]}/>
                                <span className='pl-3 text-dark'>{countries[it]}</span>
                            </h2>
                            <small className='text-primary'>View more</small>
                        </div>
                        <h2 className={'text-dark ml-auto d-flex flex-column'}>
                            <small style={{fontSize: 10}} className='text-muted'>Drug count</small>
                            <span>{props.drugsPerCountry[it]}</span>
                        </h2>
                    </div>
                </Link>
                <h4>Not enough data for ATC Coverage</h4>
            </div>
        </div>)
    }

    return (
        <div className='d-flex flex-wrap'>
            {
                props.countryAtcStatistics && props.drugsPerCountry
                    ? [...props.countryAtcStatistics].map(([key, value], index) => {
                        return <div className='ibox col-4 px-3' key={index}>
                            <div className="ibox-content">
                                <Link to={`/countries/${key}`}>
                                    <div className='d-flex justify-content-between'>
                                        <div>
                                            <h2 className='m-0 d-flex align-items-center'>
                                                <FlagComponent imageName={countryFlag[key]}/>
                                                <span className='pl-3 text-dark'>{countries[key]}</span>
                                            </h2>
                                            <small className='text-primary'>View more</small>
                                        </div>
                                        <h2 className={'text-dark ml-auto d-flex flex-column'}>
                                            <small style={{fontSize: 10}} className='text-muted'>Drug count</small>
                                            <span>{props.drugsPerCountry[key]}</span>
                                        </h2>
                                    </div>
                                </Link>
                                <h4>ATC Coverage</h4>
                                <Chart
                                    height={"300px"}
                                    chartType={"Bar"}
                                    loader={<div style={{minHeight: "100%"}}
                                                 className={'d-flex align-items-center justify-content-center bg-white'}>
                                        <CircularProgress/></div>}
                                    options={{
                                        chartArea: {width: '80%'},
                                        legend: {position: 'none'},
                                        pieHole: 0.3,
                                        vAxis: {
                                            viewWindow: {
                                                ticks: [10, 20, 30, 80],
                                                min: 0,
                                                max: 80
                                            }
                                        }
                                    }}
                                    data={arrayToDataTable(value, ['Percentage of covered drugs in ATC group', ''])}
                                />
                            </div>
                        </div>
                    })
                    : <div style={{minHeight: "60vh", width: "100%"}}
                           className={'d-flex align-items-center justify-content-center bg-white'}>
                        <CircularProgress/></div>
            }
            {props.countryAtcStatistics && props.drugsPerCountry && renderCountriesWithoutAtcCoverage()}
        </div>
    )

}

const mapStateToProps = state => {
    return {
        countryAtcStatistics: state.countries.countryAtcStatistics,
        countriesCovered: state.countries.coveredCountries,
        drugsPerCountry: state.drugs.drugsPerCountry
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onAtcStatisticsPerCountryFetch: () => dispatch(actions.getCountryStats()),
        onCountriesCoveredFetch: () => dispatch(actions.getCoveredCountries()),
        onDrugsCountFetch: () => dispatch(actions.getDrugsCountPerCountry()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Countries)
